import { render, staticRenderFns } from "./DocumentLink.vue?vue&type=template&id=bced3b9c"
import script from "./DocumentLink.vue?vue&type=script&lang=js"
export * from "./DocumentLink.vue?vue&type=script&lang=js"
import style0 from "./DocumentLink.vue?vue&type=style&index=0&id=bced3b9c&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports